import React from 'react';
import Loader from '../../components/Loader';
import Map from '../../containers/Map/index.js';
import Header from '../../containers/Header/index.js';
import Story from '../../containers/Story/index.js';
import Footer from '../../components/Footer';
import { Grid } from '@material-ui/core';
import { getStoryDetailsLaunched } from './actions';
import { connect } from 'react-redux';

class Viewer extends React.Component {
  componentDidMount() {
    this.props.getStoryDetails(this.props.location.pathname.split('/')[2]);
  }

  render() {
    const { fetching, isFullWidth } = this.props;

    let body = null;
    if (fetching) {
      body = (
        <React.Fragment>
          <Header />
          <Loader />
          <Footer />
        </React.Fragment>
      );
    } else {
      body = (
        <React.Fragment>
          <Header />
          <Grid container style={{ marginTop: '3rem' }}>
            <Grid item xs={12} sm={isFullWidth ? 12 : 5} height='100%'>
              <Map />
            </Grid>
            <Grid item xs={12} sm={isFullWidth ? 0 : 7} height='100%'>
              <Story />
            </Grid>
          </Grid>
          <Footer />
        </React.Fragment>
      );
    }

    return <div>{body}</div>;
  }
}

const mapStateToProps = state => {
  return {
    fetching: state.storyDetailsReducer.fetching,
    isFullWidth: state.updatePointOfInterestIdReducer && state.updatePointOfInterestIdReducer.isClicked
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getStoryDetails: id => {
      dispatch(getStoryDetailsLaunched(id));
    }
  };
};

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(Viewer);

export default withConnect;
